import React from 'react';
import { Typography } from "../../ecosystem";
import NotManagingMsg from './NotManagingMsg';

const RXSubjects = ({
    children,
    showNotManaging,
}) => {

    return (
        <>
            {showNotManaging && <NotManagingMsg />}
            {children}
        </>
    );
}

export default RXSubjects;
